import DOMPurify from 'dompurify';

export const SubheadingParagraph = ({ paragraph, sectionId, index }) => (
  <h3 id={`${sectionId}-${index}`} className="col-12 h3 mb-3 anchor my-3 font-bold bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
    {paragraph.src.includes('<') ? (
        <div 
          key={index} 
          className={paragraph.class}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paragraph.src) }}
        />
      ) : (
        <div key={index} className={paragraph.class}>
          {paragraph.src}
        </div>
      )
    }
  </h3>
); 